// extracted by mini-css-extract-plugin
export var banner = "course-module--banner--30369";
export var bannerContent = "course-module--banner-content--44131";
export var bannerRatioClass = "course-module--banner-ratio-class--52e47";
export var categoryCoursePillsHolder = "course-module--category-course-pills-holder--13ae6";
export var currentCategoryDescription = "course-module--current-category-description--9222a";
export var currentCategoryTittle = "course-module--current-category-tittle--e158d";
export var dataToDownloadItems = "course-module--data-to-download-items--8eac1";
export var dataToDownloadTitle = "course-module--data-to-download-title--494d4";
export var dataToDownloadWrapper = "course-module--data-to-download-wrapper--66ba4";
export var downloadItem = "course-module--download-item--759b6";
export var info = "course-module--info--235aa";
export var loader = "course-module--loader--5d6d7";
export var movieAdditionalInformation = "course-module--movie-additional-information--beac2";
export var movieCourseDescription = "course-module--movie-course-description--c2ed4";
export var movieGroup = "course-module--movieGroup--f418b";
export var restrictedFileButton = "course-module--restricted-file-button--a619a";
export var separator = "course-module--separator--2ed6c";
export var subTitle = "course-module--sub-title--40d8b";
export var tag = "course-module--tag--3867f";
export var titleCategoryWrapper = "course-module--title-category-wrapper--beec2";
export var wrapper = "course-module--wrapper--0b021";